import { useCallback, useEffect, useState } from "react";
import { getWasteStatistic } from "../../../services/container";

/**
 * Loads statisticsData.lastUpdate for the current Bilans filters/period.
 */
export function useStatisticsLastUpdate({
  periodHistoryStart,
  periodHistoryStop,
  keywordFilter,
  handleValidate,
}) {
  const [lastUpdate, setLastUpdate] = useState(null);
  const [loading, setLoading] = useState(false);

  const refreshLastUpdate = useCallback(async () => {
    if (!periodHistoryStart || !periodHistoryStop) {
      setLastUpdate(null);
      return;
    }

    setLoading(true);
    try {
      const response = await getWasteStatistic({
        periodStart: periodHistoryStart,
        periodStop: periodHistoryStop,
        keywordFilter: JSON.stringify(keywordFilter?.value || []),
      });
      setLastUpdate(response?.data?.statisticsData?.lastUpdate ?? null);
    } catch (error) {
      console.error("Failed to load statistics lastUpdate:", error);
      setLastUpdate(null);
    } finally {
      setLoading(false);
    }
  }, [periodHistoryStart, periodHistoryStop, keywordFilter]);

  useEffect(() => {
    refreshLastUpdate();
  }, [refreshLastUpdate, handleValidate]);

  return { lastUpdate, loading, refreshLastUpdate };
}
